export default __webpack_public_path__ + "static/media/1st.421b31f7.jpg";